import { widgetRegistry } from '../../infrastructure/registry/WidgetRegistry';
import { GodModeWidget } from './GodModeWidget';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';

export const superAdminGodModeConfig: WidgetConfig = {
  id: 'superadmin-god-mode',
  category: 'statistics',
  title: 'God Mode Overview',
  defaultSize: { w: 12, h: 2 },
  priority: 1,
  refreshStrategy: 'interval',
  refreshIntervalMs: 60000,
};

export function registerSuperAdminWidgets() {
  widgetRegistry.register(superAdminGodModeConfig, GodModeWidget);
}
